module.exports = __webpack_public_path__ + "img/pending_zone_selected.c3b652c3.svg";